import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import moment, { Moment } from 'moment'

import { faBalanceScale } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '../../App/Components/Button/Button'
import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

import IProps from './IProps'
import style from './style.scss'

const CompareDateRangeSelection: FunctionComponent<IProps> = ({
    isDisplayCompare = true,
    onSelected,
    availableSpans,
    dateFormat,
}) => {
    const { t } = useTranslation()
    const [from1, setFrom1] = useState<Moment>(moment().startOf('isoWeek'))
    const [to1, setTo1] = useState<Moment>(moment().endOf('isoWeek'))
    const [from2, setFrom2] = useState<Moment>(moment().startOf('isoWeek'))
    const [to2, setTo2] = useState<Moment>(moment().endOf('isoWeek'))
    const [span, setSpan] = useState<'week' | 'month' | 'year'>('week')
    const [isCompare, setIsCompare] = useState<boolean>(false)

    const toggleCompare = isDisplayCompare ? undefined : { display: 'none' }

    const onCompareClick = () => {
        if (isCompare) {
            setIsCompare(false)

            onSelected(span, { from: from1, to: to1 }, undefined)
        } else {
            const newFrom2 = from1.clone().subtract(1, span)
            const newTo2 = to1.clone().subtract(1, span)

            setIsCompare(true)
            setFrom2(newFrom2)
            setTo2(newTo2)

            onSelected(
                span,
                { from: from1, to: to1 },
                { from: newFrom2, to: newTo2 }
            )
        }
    }

    return (
        <div className={style.wrapper}>
            <DateRangeSelection
                onSelected={(newSpan, newFrom1, newTo1) => {
                    let newFrom2 = from2
                    let newTo2 = to2
                    if (isCompare && newSpan !== span) {
                        newFrom2 = newFrom1.clone().subtract(1, newSpan)
                        newTo2 = newTo1.clone().subtract(1, newSpan)
                        setFrom2(newFrom2)
                        setTo2(newTo2)
                    }

                    setFrom1(newFrom1)
                    setTo1(newTo1)
                    setSpan(newSpan)

                    if (onSelected) {
                        onSelected(
                            newSpan,
                            { from: newFrom1, to: newTo1 },
                            isCompare
                                ? { from: newFrom2, to: newTo2 }
                                : undefined
                        )
                    }
                }}
                span={span}
                from={from1}
                to={to1}
                isCompare={isCompare}
                zIndex={true}
                availableSpans={availableSpans}
            />

            {isCompare ? (
                <DateRangeSelection
                    onSelected={(newSpan, from, to) => {
                        setFrom2(from)
                        setTo2(to)
                        setSpan(newSpan)

                        if (onSelected) {
                            onSelected(
                                newSpan,
                                { from: from1, to: to1 },
                                { from, to }
                            )
                        }
                    }}
                    span={span}
                    from={from2}
                    to={to2}
                    showDateFormat={false}
                    availableSpans={availableSpans}
                >
                    <FontAwesomeIcon
                        icon={faBalanceScale}
                        style={{ marginRight: '2.3em', cursor: 'pointer' }}
                        title={t('Compare')}
                        onClick={onCompareClick}
                    />
                </DateRangeSelection>
            ) : (
                <Button
                    cssStyle={toggleCompare}
                    size="small"
                    onClick={onCompareClick}
                >
                    {t('Compare')}
                </Button>
            )}
        </div>
    )
}

export default CompareDateRangeSelection
